<template>
  <div :class="$setClasses"
       :title="bannerLabel">
    {{ bannerLabel }}
    <el-tooltip
      effect="dark"
      placement="top-start"
    >
      <template #content>
        <div class="partner-discount-info">
          {{ $t('base.partnerDiscountInfoLine1', { partnerName }) }}<br/>
          {{ $t('base.partnerDiscountInfoLine2') }}<br/>
          {{ $t('base.partnerDiscountInfoLine3') }}
        </div>
      </template>
      <font-awesome-icon
        :icon="['fal', 'circle-info']"
        class="partner-discount-icon"
      />
    </el-tooltip>
  </div>
</template>

<script>
import { mapState } from 'pinia';
import { useProjectStore } from '@/stores';

export default {
  name: 'PartnerDiscountBanner',
  nameClassStyle: 'partner-discount-banner',
  props: {
    rate: {
      type: Number,
      default: 0,
    },
    labelKey: {
      type: String,
      default: 'base.partnerDiscountBanner',
    },
    labelWithoutRateKey: {
      type: String,
      default: 'base.partnerDiscountBannerWithoutRate',
    },
  },
  computed: {
    ...mapState(useProjectStore, ['projectSelected']),
    partnerName() {
      return this.projectSelected?.params?.partner_name;
    },
    formattedRate() {
      const rate = Math.abs(Number(this.rate || 0));
      if (Number.isInteger(rate)) {
        return String(rate);
      }
      return rate.toFixed(2).replace(/\.?0+$/, '').replace('.', ',');
    },
    bannerLabel() {
      if (!this.rate) {
        return this.$t(this.labelWithoutRateKey);
      }
      return this.$t(this.labelKey, { rate: this.formattedRate });
    },
  },
};
</script>

<style scoped lang="scss">
.partner-discount-icon {
  margin-left: 4px;
}
.partner-discount-info {
  max-width: 400px;
}
.partner-discount-banner {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  min-height: 10px;
  padding: 2px 10px;
  border-radius: 999px;
  background: var(--nxt-color-yellow);
  color: var(--nxt-color-primary);
  font-size: 9px;
  font-weight: var(--nxt-font-weight-bold);
  letter-spacing: 0.04em;
  line-height: 1.2;
  text-align: center;
  text-transform: uppercase;
  white-space: nowrap;
}
</style>
